export type NationalRouteStopKind = "origin" | "intermediate" | "destination"

export interface NationalRouteStop {
  partyId: string
  kind: NationalRouteStopKind
}

export function syncNationalRouteStops(
  senderId: string,
  recipientId: string,
  previous: NationalRouteStop[] = [],
): NationalRouteStop[] {
  const intermediate = previous.filter(stop => stop.kind === "intermediate")
  const next: NationalRouteStop[] = []
  if (senderId) next.push({ partyId: senderId, kind: "origin" })
  next.push(...intermediate)
  if (recipientId) next.push({ partyId: recipientId, kind: "destination" })
  return next
}
